window.Page = {

    containers : document.querySelectorAll('.progetto-program-day-container'),

    dayButtons       : document.querySelectorAll('.progetto-nav-day'),
    dayButtonActive  : document.querySelector('.progetto-nav-day[aria-selected]'),
    daySections      : document.querySelectorAll('.progetto-program-day-container'),
    daySectionActive : document.querySelector('.progetto-program-day-container[aria-visible]'),

    // Let's launch this thing
    liftoff : () => {
        
        Page.activateDay()
        Page.Map.initMap()

    },

    // Show the popup card on click 
    showHideCardOnClick : (button) => {

        // Get the target card and the eventual active card
        let activeCard = document.querySelector('.card-active');
        let targetCard = document.getElementById(button.value);
        
        // If the target is the same as the active swap the class in and out
        if (activeCard == targetCard) {
            targetCard.classList.toggle('card-active')
            return;
        }

        if (activeCard) activeCard.classList.toggle('card-active')

        targetCard.classList.toggle('card-active')

    },

    // Activate the section on click
    activateDay : () => {

        Page.dayButtons.forEach(dayButton => {
            dayButton.addEventListener('click' , () => {

                // If we have clicked on the currently active button we don't have to do anything
                if (dayButton == Page.dayButtonActive) return;

                // Disable the active parts
                Page.dayButtonActive.removeAttribute('aria-selected')
                Page.daySectionActive.removeAttribute('aria-visible')

                // Store references to the new active parts
                Page.dayButtonActive  = dayButton
                Page.daySectionActive = document.getElementById(dayButton.value)

                // Set attributes on the newsly active items
                Page.dayButtonActive.setAttribute('aria-selected' , true);
                Page.daySectionActive.setAttribute('aria-visible' , true)

                // Remove the markers and then place new ones
                Page.Map.removeMarkersOnMap()
                Page.Map.placeMarkersOnMap()

            })
        })

    },


    // All the functions related to the map
    Map : {

        // Mapbox Settings
        token    : 'pk.eyJ1IjoidGVhdHJvZ3JhbmRlIiwiYSI6ImNtbTNudGxidzAyaXkydHMydnR2aDIweWwifQ.-3s3mShQ1tgchQy-7-oiSA',
        settings : {
            container                    : 'mapbox',
            style                        : 'mapbox://styles/teatrogrande/cmm3nuwt4001f01sbfsbg63vx', // Custom, Black and white style
            projection                   : 'globe', // display the map as a globe
            performanceMetricsCollection : false,
            zoom                         : 12, // initial zoom level, 0 is the world view, higher values zoom in
            minZoom                      : 11, // Minimum zoom level
            maxZoom                      : 19,
            center                       : [10.220810197692533,45.53687212540244], // center the map on this longitude and latitude
            cooperativeGestures          : true,
        },
        markers : [],

        // Initiate the map
        initMap : () => {

            // If we don't have the mapbox container we can do nothing
            if (!document.getElementById('mapbox')) return;

            Page.Map.createMap()
            Page.Map.placeMarkersOnMap()

        },

        // Initiate the map
        createMap : () => {

            // Set the API token
            mapboxgl.accessToken = Page.Map.token;

            // Initiate the map and store a reference
            Page.Map.map = new mapboxgl.Map(Page.Map.settings);

            // Store a reference to the NAV object
            Page.Map.nav = new mapboxgl.NavigationControl();
            
            // Set a few control settings
            Page.Map.map.scrollZoom.disable();
            Page.Map.map.addControl(Page.Map.nav, 'bottom-right');

        },

        // Attach Markers
        placeMarkersOnMap : () => {

            // Grab all the JSON data
            let entries     = document.querySelectorAll('.progetto-program-day-container[aria-visible] .progetto-entry');
            let entriesJSON = [];

            // Loop and extract the JSON data from each entry
            entries.forEach(entry => {
                entriesJSON.push(entry.dataset.geodata); // Append the json to the array
            })

            // Loop through the Geo JSON data and create the markers
            for (let entryJSON of entriesJSON) {

                // Parse the JSON
                let parsedJSON = JSON.parse(entryJSON);

                // create a HTML element for each feature
                const el = document.createElement('button');
                el.className = 'marker progetto-map-marker';
                el.innerHTML = parsedJSON.properties.number
                el.setAttribute('onclick' , 'Page.showHideCardOnClick(this)');
                el.setAttribute('value' , "card-" + parsedJSON.properties.uuid);

                if (parsedJSON.properties.color) {
                    el.style.setProperty("--accent", parsedJSON.properties.color);
                }

                // Pass the div.marker to the Marker instance
                Page.Map.markers.push(new mapboxgl.Marker(el).setLngLat(parsedJSON.geometry.coordinates).addTo(Page.Map.map));

            }

        },

        // Remove markers from the map
        removeMarkersOnMap : () => {
            for (let marker of Page.Map.markers) { marker.remove(); }
        }
    
    }

};

Page.liftoff()